// DS: i9.17
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const DollarOffers: React.FC<Props> = props => (
  <IconWrap {...props} disableDefaultColors>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M16.956 5.834c1.185.146 2.32.558 2.997 1.236Q20.98 8.08 20.96 9.703l-.03.042h-2.886q0-.991-.498-1.53-.498-.54-1.34-.54-.874 0-1.311.422-.427.412-.427 1.102 0 .656.446 1.068.458.404 1.667.8 1.494.488 2.469 1.01.986.512 1.464 1.201.487.69.487 1.683 0 1.455-1.098 2.339-1.087.874-2.946 1.034V20H15.34v-1.657q-1.26-.11-2.255-.564-.996-.454-1.555-1.287t-.528-2.07l.02-.041h2.885q0 1.127.631 1.615.63.487 1.585.487.924 0 1.412-.403.498-.413.498-1.102 0-.682-.477-1.11-.468-.43-1.617-.8-1.503-.453-2.489-.959-.975-.513-1.463-1.203-.477-.697-.477-1.716 0-1.413 1.087-2.313c.731-.606 1.51-.962 2.743-1.068V4h1.616zM8.7 15c.166 0 .301.135.301.3v1.4a.3.3 0 0 1-.3.3H6.476a.3.3 0 0 1-.3-.3v-1.4a.3.3 0 0 1 .3-.3zm0-3.5c.166 0 .301.135.301.3v1.4a.3.3 0 0 1-.3.3H4.888a.3.3 0 0 1-.301-.3v-1.4c0-.165.135-.3.3-.3zm0-3.5c.166 0 .301.135.301.3v1.4a.3.3 0 0 1-.3.3H3.3a.3.3 0 0 1-.3-.3V8.3a.3.3 0 0 1 .3-.3z"
      />
    </svg>
  </IconWrap>
);
DollarOffers.displayName = 'DollarOffers';

export default DollarOffers;
